import { Button } from 'antd';
import styled from 'styled-components';
export const Container = styled(Button)`
  svg {
    transform: rotate(180deg);
  }
`;